import * as fetchService from '../../../shared/services/fetch';
import {getStore} from '../../../store-factory';
import {handleError} from '../../../shared/services/error-handlers';
import {oktaToken} from '../../../shared/services/okta';

const basePath = '/api';

export async function getRgaCollection(rgaFilterCriteria, isExport, pageno) {

    const pageNumber = 100000;
    const endPoint = isExport === 'EXCEL' ?
    `${basePath}/rga/search?export=EXCEL&pageSize=${pageNumber}&pageNumber=1` :
    `${basePath}/rga/search?pageSize=100&pageNumber=${pageno}`;

    const fetchOptions = {
        body: JSON.stringify(rgaFilterCriteria),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return isExport === 'EXCEL' ?
            response :
            response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getRgaDetailAnalysisInfo(rga) {

    const endPoint = `${basePath}/rga/analysis-info?Rgano=${rga.rgaNumber}&PartNo=${rga.partNumber}&SapClmno=${rga.warrantyClaimNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getRgaDetailDealerInfo(rga) {

    const endPoint = `${basePath}/rga/dealer-data?Rgano=${rga.rgaNumber}&PartNo=${rga.partNumber}&SapClmno=${rga.warrantyClaimNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getRgaDetailConsignmentInfo(rga) {

    const endPoint = `${basePath}/rga/consignment-detail?Rgano=${rga.rgaNumber}&PartNo=${rga.partNumber}&SapClmno=${rga.warrantyClaimNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getRgaDetailQandA(rga) {

    const endPoint = `${basePath}/rga/question-answer?Rgano=${rga.rgaNumber}&PartNo=${rga.partNumber}&SapClmno=${rga.warrantyClaimNumber}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function postRgaAnalysisValuesAPI(rgaAnalysis) {

    const endPoint = `${basePath}/rga/analysis-info`;

    const fetchOptions = {
        body: JSON.stringify(rgaAnalysis),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function postRgaDealerInfoValuesAPI(rgaDealerInfo) {

    const endPoint = `${basePath}/rga/dealer-data`;

    const fetchOptions = {
        body: JSON.stringify(rgaDealerInfo),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

export async function postRgaConsignmentValuesAPI(rgaConsignmentInfo) {

    const endPoint = `${basePath}/rga/consignment-detail`;

    const fetchOptions = {
        body: JSON.stringify(rgaConsignmentInfo),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

/* Additional data API calls can be added here */

export async function getRgaAdditionalDataType(rgaUnit) {

    const endPoint = `${basePath}/rga/rga-unit/${rgaUnit}/additional-data-types/domains`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getRgaAdditionalTestParameter(rgaUnit) {

    const endPoint = `${basePath}/rga/rga-units/${rgaUnit}/test-parameters/domains`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getRgaAdditionalData(rgaNumber, rgaUnit) {

    const endPoint = `${basePath}/rga/${rgaNumber}/rga-unit/${rgaUnit}/additional-data-info`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function postRgaAdditionalDataByDataType(rgaDealerInfo) {

    const endPoint = `${basePath}/rga/additional-data-parameters`;

    const fetchOptions = {
        body: JSON.stringify(rgaDealerInfo),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function postRgaAdditionalDataValuesAPI(rgaAdditionalData, isUpdate) {

    const endPoint = `${basePath}/rga/${rgaAdditionalData.rgaNumber}/rga-unit/${rgaAdditionalData.responsibleUnit}/additional-data-info`;

    const fetchOptions = {
        body: JSON.stringify(rgaAdditionalData),
        method: isUpdate ? 'PUT' : 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

/* Mass update Rga Request PUT API */

export async function postRgaMassUpdateRequest(rgaMassUpdateRequest) {

    const endPoint = `${basePath}/rga/mass-update`;

    const fetchOptions = {
        body: JSON.stringify(rgaMassUpdateRequest),
        method: 'PUT'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (error) {

        return handleError(error);

    }

}

/* Mass upload Rga Request POST API */

export async function postRgaUpload(file) {

    const endPoint = `${basePath}/rga/upload`;

    const formData = new FormData();

    formData.set('file', file);

    const accessToken = await oktaToken('accessToken');

    const state = await getStore().getState();

    const selectedSapEnvironment = state.appConfig.sapEnvironments.length > 0 ?
                state.appConfig.sapEnvironments.find(environment => environment.defaultVal).name :
                '';

    const preferredLanguage = state.user.details.settings.language.primaryLanguage.key.length ?
                state.user.details.settings.language.primaryLanguage.key :
                'EN';

    const fetchOptions = {
        body: formData,
        headers: {
            'Accept-Language': preferredLanguage,
            Authorization: `Bearer ${accessToken.accessToken}`,
            sapEnvironment: selectedSapEnvironment
        },
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, fetchOptions);

        return response;

    } catch (error) {

        return handleError(error);

    }

}

export async function getRgaDownloadReport(payload) {

    const endPoint = `${basePath}/rga/report/BO`;

    const fetchOptions = {
        body: JSON.stringify(payload),
        method: 'POST'
    };

    try {

        return await fetchService.fetch(endPoint, fetchOptions);

    } catch (response) {

        return handleError(response);

    }

}



// WEBPACK FOOTER //
// ./src/rga/shared/repositories/index.js